export const baseUrlDev =
  "https://arena-fs.arenaplus.fastcloudnetwork.com/api/";
export const baseUrlProd = "https://app.tvpakistanlive.com/api/";
export const providerName = "https://arenaxui.fastcloudnetwork.com:25463";
export const reskinName = "pakistan";
export const demo = false;
